import { VoucherPrintOrgHeading, VoucherPrintOrgAddress, VoucherPrintDepartmentFooter } from "../VoucherPrintOrgHeader";
import PrintCommon from "app/common/Component/Print/PrintCommon";
import { formatMoney, formatPrintPatientCodeSuffix, getDateTime, hideMiddleDigits } from "app/common/LocalFunction";
import React, { memo } from "react";
import QrSurveySection from "app/common/Component/Print/QrSurveySection";

const PrintFormRetailProductServiceA5 = ({
  componentRef,
  rowDataVoucher,
  initialPatient,
  staffRevenues,
}) => {
  const namesText = staffRevenues
    ?.map((item) => item?.staff?.staffName)
    .join(" ; ");
  let totalQuantity = 0;

  const totalValue =
    rowDataVoucher?.items?.length > 0 &&
    rowDataVoucher?.items?.reduce(
      (acc, curr) => {
        return {
          totalQuantity: acc.totalQuantity + (curr?.quantity || 0),
          totalPrice:
            acc.totalPrice + (curr?.price || 0) * (curr?.quantity || 0),
          totalAmount:
            acc.totalAmount + (curr?.invoiceItem?.subAmountActuallyPaid || 0),
          totalPaid:
            acc.totalPaid +
            (curr?.invoiceItem?.subTotalBillPatientPaid || 0) -
            (curr?.moneyAfterDiscount || 0),
          totalCurrentPaid: acc.totalCurrentPaid + curr?.moneyAfterDiscount,
          totalDebit:
            acc.totalDebit +
            (curr?.invoiceItem?.subAmountActuallyPaid -
              curr?.invoiceItem?.subTotalBillPatientPaid),
        };
      },
      {
        totalQuantity: 0,
        totalAmount: 0,
        totalPrice: 0,
        totalPaid: 0,
        totalCurrentPaid: 0,
        totalDebit: 0,
      }
    );
  return (
    <>
      <PrintCommon
        ref={componentRef}
        marginPage="2mm"
        hidden={false}
        size="A5"
        orientation={"landscape"}
      >
        <header className="printHeader w-100 flex justify-between print-voucher">
          <table className="table-layout-fixed">
            <div className="wraper-print">
              <div className="container-print">
                <VoucherPrintOrgHeading department={rowDataVoucher?.department} withDepartmentName />
                <VoucherPrintOrgAddress department={rowDataVoucher?.department} phonePrefix="Điện Thoại: " />
                <div className="mt-5 text-center">
                  <h4 style={{ fontWeight: "bold", fontSize: "16px" }}>
                    PHIẾU THU
                  </h4>
                  <div className="center">
                    {getDateTime(rowDataVoucher?.voucherDate, "", "DD/MM/YYYY")}
                  </div>
                </div>
              </div>
            </div>
          </table>
        </header>
        <div className="cards-container flex justify-center">
          <div className="container-print-A5">
            <table
              border="0"
              cellPadding="1"
              cellSpacing="0"
              style={{
                width: "100%",
                fontFamily: "Arial, sans-serif",
                fontSize: "14px",
                borderSpacing: "0px 4px",
              }}
            >
              {/* Số phiếu: <mã> (dd/MM/yyyy)  Khách hàng: <tên> - <sđt> */}
              <tbody>
                <tr>
                  <td style={{ width: "50%" }}>
                    Số phiếu:{" "}
                    <b>
                      {rowDataVoucher?.code || "Chưa có mã"}{" "}
                      {getDateTime(rowDataVoucher?.voucherDate, "", "DD/MM/YYYY")}
                    </b>
                  </td>
                  <td style={{ width: "50%" }}>
                    Khách hàng:{" "}
                    <b>
                      {rowDataVoucher?.patient?.displayName || ""}{" "}
                      {formatPrintPatientCodeSuffix(rowDataVoucher?.patient, initialPatient)}
                      {rowDataVoucher?.patient?.phoneNumber
                        ? ` - ${hideMiddleDigits(rowDataVoucher?.patient?.phoneNumber)} `
                        : ""}
                    </b>
                  </td>
                </tr>
                <tr>
                  {console.log("rowDataVoucher", rowDataVoucher)}
                  <td>
                    Nhân viên:{" "}
                    {rowDataVoucher?.accountant?.staffName
                      ? `${rowDataVoucher?.accountant?.staffName} ${rowDataVoucher?.accountant?.position
                        ? `(${rowDataVoucher?.accountant?.position?.name})`
                        : ""
                      } `
                      : "Không rõ"}
                  </td>
                  <td>
                    <td>Tư vấn: {namesText}</td>
                  </td>
                </tr>
              </tbody>
            </table>

            <div className="table-responsive">
              <table className="service-table">
                <thead>
                  <tr>
                    <th>STT</th>
                    <th>TÊN HÀNG</th>
                    <th>ĐƠN VỊ</th>
                    <th>SL</th>
                    <th>ĐƠN GIÁ</th>
                    <th>KHUYẾN MÃI</th>
                    <th>THÀNH TIỀN</th>
                  </tr>
                </thead>
                <tbody>
                  {rowDataVoucher?.items?.length > 0 ? (
                    rowDataVoucher?.items?.map((it, index) => {
                      return (
                        <>
                          <tr key={`srv-${it.id || index}`}>
                            <td>{index + 1}</td>
                            <td>
                              {it?.invoiceItem?.patientServiceRegister?.name ||
                                it?.invoiceItem?.drugOrder?.name ||
                                it?.invoiceItem?.treatmentPlanCard?.name ||
                                "Dịch vụ không rõ"}
                            </td>
                            <td>{ }</td>
                            <td>
                              {it?.invoiceItem?.quantity ||
                                it?.invoiceItem?.soldQuantity ||
                                0}
                            </td>
                            <td>
                              {formatMoney(
                                it?.invoiceItem?.patientServiceRegister
                                  ?.price ||
                                it?.invoiceItem?.drugOrder?.price ||
                                it?.invoiceItem?.treatmentPlanCard?.price ||
                                0
                              )}
                            </td>
                            <td>
                              {" "}
                              {formatMoney(
                                it?.invoiceItem?.patientServiceRegister
                                  ?.discount ||
                                it?.invoiceItem?.drugOrder?.discount ||
                                it?.invoiceItem?.treatmentPlanCard
                                  ?.discount ||
                                0
                              )}
                            </td>
                            <td>
                              {" "}
                              {formatMoney(
                                it?.invoiceItem?.subAmountActuallyPaid || 0
                              )}
                            </td>
                          </tr>
                        </>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={7}>Không có dữ liệu</td>
                    </tr>
                  )}
                </tbody>

                <tfoot style={{ border: "1px solid #ccc" }}>
                  <tr>
                    <td
                      colSpan={3}
                      rowSpan={4}
                      style={{
                        verticalAlign: "top",
                        border: "none",
                        paddingTop: 4,
                      }}
                    >
                      <b>Ghi chú:</b>
                      {rowDataVoucher?.note || "Không có ghi chú"}
                    </td>
                    <td
                      colSpan={3}
                      style={{ textAlign: "right", border: "none" }}
                    >
                      <b>Tổng tiền (VNĐ):</b>
                    </td>
                    <td
                      colSpan={2}
                      style={{ textAlign: "right", border: "none" }}
                    >
                      {formatMoney(totalValue?.totalAmount)}
                    </td>
                  </tr>
                  <tr>
                    <td
                      colSpan={3}
                      style={{ textAlign: "right", border: "none" }}
                    >
                      <b>Khách Hàng Trả:</b>
                    </td>
                    <td
                      colSpan={2}
                      style={{ textAlign: "right", border: "none" }}
                    >
                      {formatMoney(totalValue?.totalCurrentPaid)}
                    </td>
                  </tr>
                  <tr>
                    <td
                      colSpan={3}
                      style={{ textAlign: "right", border: "none" }}
                    >
                      <b>Đã Thanh Toán:</b>
                    </td>
                    <td
                      colSpan={2}
                      style={{ textAlign: "right", border: "none" }}
                    >
                      {formatMoney(totalValue?.totalPaid)}
                    </td>
                  </tr>
                  <tr>
                    <td
                      colSpan={3}
                      style={{ textAlign: "right", border: "none" }}
                    >
                      <b>Còn nợ:</b>
                    </td>
                    <td
                      colSpan={2}
                      style={{ textAlign: "right", border: "none" }}
                    >
                      {formatMoney(totalValue?.totalDebit)}
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>

            <div style={{ textAlign: "center", marginTop: "10px" }}>
              <div
                style={{
                  textAlign: "center",
                  fontSize: "0.75rem",
                  textTransform: "uppercase",
                }}
              >
                <i>
                  Quý khách vui lòng kiểm tra dịch vụ/sản phẩm trước khi rời
                  khỏi quầy. Sản phẩm sẽ không được đổi trả. Khi khách hàng
                  tự ý ngưng dịch vụ sẽ không được hoàn lại tiền mà sẽ được
                  tư vấn chuyển sang dịch vụ khác. Dịch vụ có thời hạn sử
                  dụng trong vòng 12 tháng kể từ thời điểm thu tiền và xuất
                  hóa đơn. Xin cảm ơn Quý khách và hẹn gặp lại !!!
                </i>
              </div>
              <QrSurveySection patient={rowDataVoucher?.patient} />
            </div>
          </div>
        </div>
      </PrintCommon>
    </>
  );
};

export default memo(PrintFormRetailProductServiceA5);
